/**
 * Utilitário para classes CSS (usado por componentes UI).
 */
export function cn(...classes: (string | undefined | null | false)[]): string {
  return classes.filter(Boolean).join(' ');
}
